import Splide from '@splidejs/splide';
import { setCarouselCssVar } from '../libraries/splide-helpers';
import { throttle } from 'throttle-debounce';

export default() => {

  const cardCarousels = document.getElementsByClassName('js-card-slider');

  if( !cardCarousels ) {
    return;
  }

  Array.from(cardCarousels).forEach((carousel) => {

    // Only show 2 if there's only two
    const totalSlides = carousel.querySelectorAll('.splide__slide').length;
    const maxSlides = Math.min(totalSlides, 3);

    if( totalSlides <= 1 ) {
      return;
    }

    const type = carousel?.dataset?.type ?? 'slide';
    const perPage = carousel?.dataset?.perPage ?? maxSlides;

    var splide = new Splide( carousel, {
      type: type,
      perPage: perPage,
      gap: '16px',
      pagination: false,
      drag: totalSlides > maxSlides,
      breakpoints: {
        1060: {
          perPage: 2,
          drag: totalSlides > 2,
        },
        760: {
          perPage: 1,
          drag: totalSlides > 1,
          focus  : 'center',
        },
      }
    
    });

    splide.mount();

    // Recalculate the overflow fade width
    setCarouselCssVar(carousel);

  });

  // Recalculate the overflow fade width
  window.addEventListener('resize', throttle(250, () => {
    Array.from(cardCarousels).forEach((carousel) => {
      setCarouselCssVar(carousel);
    });
  }))

}